import React, { useEffect, useState, useRef, useMemo } from "react";
import Modal from "react-modal";
import { useNavigate, Link } from "react-router-dom";
import { FaTimes } from "react-icons/fa"; // Importing the close icon from react-icons
import { TextfieldwithLabel } from "../Buttons/Textfield";
import axios from "axios";
import { fetchComboData, fetchComboDataWithWhere } from "../../services/api";
import { getHeaders } from "../../utility/getHeader";
import fetchData from "../../functions/fetchData";
import { SubmitButton } from "../Buttons/Textfield";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CardComponent from "../../components/cards/CardComponent";
import FinalBillModal from "./FinalBillModal";
import fetchOrderDetails from "../../functions/fetchOrderDetails";
import updateData from "../../functions/updateData";
import { FaRedo } from "react-icons/fa"; // Import refresh icon
import CustomerDetailsModal from "./customerDetailsModal";
import LineQRDiscountModal from "./LineQRDiscountModal";
import { getUserName } from "../../functions/storageUtils"; // Import getUserName for cashier name
import customerDisplayManager from "../../services/CustomerDisplayManager"; // Import customer display manager
import { getNextSetupDate } from "../../utils/setupDateUtils"; // ✅ Import setup date utility
import "./CheckBillModal.css";


const customStyles = {
  content: {
    position: "relative",
    top: "auto",
    left: "auto",
    right: "auto",
    bottom: "auto",
    margin: "0",
    transform: "none",
    width: "100%",
    height: "auto",
    maxWidth: "none",
    maxHeight: "none",
    padding: "0",
    border: "none",
    borderRadius: "12px",
    overflow: "visible",
    background: "transparent",
    inset: "auto"
  },
  overlay: {
    zIndex: 1050,
    backgroundColor: "rgba(0, 0, 0, 0.6)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "20px",
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  },
};

const getCurrentDate = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0"); // Months are 0-based
  const day = String(today.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};
const getCurrentTime = () => {
  const now = new Date();
  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");
  const seconds = String(now.getSeconds()).padStart(2, "0");
  return `${hours}:${minutes}:${seconds}`;
};

//console.log(getCurrentTime()); // Output: HH:MM:SS

//console.log(getCurrentDate()); // Output: YYYY-MM-DD

const CheckBillModal = ({ isOpen, customer, uptableList, onClose, refreshTrigger }) => {
  const [formdata, setFormData] = useState({
    pmode: "Cash", // Default to "Cash"
    discAmount: 0,
    discountType: "percentage", // Default to "percentage"
    phones: ""
    // other fields
  });
  const [companyInfo, setcompanyInfo] = useState([]);
  const [TotalTablelist, setTotaltablelist] = useState(0);
  const [TaxesData, setTaxesData] = useState(0);
  const [selectedTable, setSelectedTable] = useState(null); // Table selection
  const [selectedTables, setSelectedTables] = useState([]); // Multiple table selection for merging
  const [isMergeMode, setIsMergeMode] = useState(false); // Toggle merge mode
  const [FinalBillData, setFinalBillData] = useState([]); // Manage the table data state
  const [OrderItemsData, setOrderItemsData] = useState([]); // Manage the table data state
  const [isLineQRModalOpen, setLineQRModalOpen] = useState(false);


  // Handle table selection
  const handleTableClick = (tableNumber) => {
    setSelectedTable(tableNumber);

    toast.success(`Selected Table: ${tableNumber}`);
  };
  const [getTax, setTax] = useState([]);
  const [getUnit, setUnits] = useState([]);
  const [paymentOptions, setpaymentOptions] = useState([]);
  const [finalData, setFinalData] = useState([]);
  const [changeMoney, setChangeMoney] = useState("");
  const [phones, setphones] = useState("");
  const printRef = useRef();
  const [latestBillId, setLatestBillId] = useState(null);


  const [reload, setReload] = useState(false);
  const [data, setData] = useState([]);
  const [errors, setErrors] = useState({});
  const [images, setImages] = useState([]);
  const [isCustomerModalOpen, setCustomerModalOpen] = useState(false);
  const [customerDetails, setCustomerDetails] = useState({
    name: "",
    phone: "",
    email: "",
  });

  //   if (!customer) return null;

  const refreshTables = (event) => {
    fetchData("tablelist", setTotaltablelist, "id", { status: "1" });
    setIsBillSaved(false);
  };

  // Function to refresh tables and clear bill summary
  const refreshTablesAndClearBill = async () => {
    try {
      // Refresh table list
      await fetchData("tablelist", setTotaltablelist, "id", { status: "1" });
      
      // Clear bill summary data
      setFinalData([]);
      setSelectedTable(null);
      setSubtotal(0);
      setDiscAmount(0);
      settaxAmount(0);
      setroundoffAmount(0);
      setgrandAmount(0);
      settotalAmount(0);
      setsubtotalAfterDiscount(0);
      setIsBillSaved(false);
      setLatestBillId(null);
      
      // Clear merge states
      setSelectedTables([]);
      setIsMergeMode(false);
      
      // Clear form data
      setFormData({
        pmode: "Cash",
        discAmount: 0,
        discountType: "percentage",
        phones: "",
        paidAmount: ""
      });
      setChangeMoney("");
      setphones("");
      
      console.log("Tables refreshed and bill summary cleared");
    } catch (error) {
      console.error("Error refreshing tables:", error);
    }
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    //console.log(formdata);
    try {
      const post1 = await axios.post(
        "/insertdata/items",
        {
          iname: formdata.iname,
          unit: formdata.unit,
          tax: formdata.tax,
          mrp: formdata.mrp,
          offerprice: formdata.offerprice,
          catid: formdata.category,
          subcatid: formdata.subcat,
          description: formdata.desc,
        },
        getHeaders()
      );
      const formdata1 = e.target;
      const formData = new FormData();
      Array.from(formdata1.images.files).forEach((file) => {
        formData.append("images", file);
      });
      console.log(post1.data.id);
      formData.append("product_id", post1.data.id); // Assuming post1 returns item ID

      const post2 = await axios.post("/addnewproduct/item_images", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${localStorage.getItem("token")}`, // Again, make sure the token is correct
        },
      });
      // Immediately fetch updated data after adding an item
      // await fetchData("items", setData, "id", {});
      //  onItemAdded(); // Call this to trigger the reload function in NewItem
      toast.success("Item added successfully!");
      setImages([]);
      // Optionally add a delay before closing the modal to ensure the toast is visible
      setTimeout(() => {
        onClose(); // Close modal
      }, 1000); // Adjust the delay as needed
      //console.log("Fetched data after add:", data);
    } catch (err) {
      toast.error("Error in adding Item");
      console.error(err.message);
    }

    // Clear form data and errors
    // setFormData({});
    setErrors({});
  };
  const navigate = useNavigate();
  //handle change money
  const handleChangeMoney = (e) => {
    const paidAmount = parseFloat(e.target.value) || 0; // Convert to a number or set to 0 if empty
    const grandTotal = Math.round(
      finalData.reduce((acc, item) => acc + item.total_price, 0) * 1.07
    ); // Calculate the grand total
    const change = paidAmount - grandAmount; // Calculate the change
    setChangeMoney(change.toFixed(2)); // Update the state with the calculated change
    setFormData((prevData) => ({
      ...prevData,
      paidAmount: e.target.value, // Update the paid amount in formdata
    }));
  };
  const [subtotal, setSubtotal] = useState(0);
  const [discAmount, setDiscAmount] = useState(0);
  const [taxAmount, settaxAmount] = useState(0);
  const [roundoffAmount, setroundoffAmount] = useState(0);
  const [grandAmount, setgrandAmount] = useState(0);
  const [totalAmount, settotalAmount] = useState(0);
  const [subtotalAfterDiscount, setsubtotalAfterDiscount] = useState(0);
  const [isBillSaved, setIsBillSaved] = useState(false);
  const [isCustomerPhoneModalOpen, setIsCustomerPhoneModalOpen] = useState(false);
  const [currencySign, setCurrencySign] = useState("฿"); // Default to Thai Baht







  const handleComboChange = (e) => {
    const { value } = e.target;
    setFormData((prevData) => ({ ...prevData, pmode: value }));

    console.log("Payment Mode Selected:", value); // ✅ Debugging
    if (value === "Credit") {
      console.log("Opening Customer Details Modal"); // ✅ Debugging
      setCustomerModalOpen(true);
    }
  };


  // Handle changes to the discount type (percentage or amount)
  const handleDiscountTypeChange = (e) => {
    setFormData({
      ...formdata,
      discountType: e.target.value, // Update the discountType value based on selection
    });

    // Recalculate discount immediately after changing type
    //handlediscount({ target: { value: discAmount.toString() } });
  };


  // Fetch subcategories based on selected category
  const handleTableHistory = async (tableName) => {
    setSelectedTable(tableName);
    setFormData((prevData) => ({ ...prevData, paidAmount: "", pmode: "Cash" }));
    setChangeMoney("");
    setDiscAmount("0");
    setIsBillSaved(false); // Reset bill saved status when selecting a new table

    fetchData("order_items", setFinalData, "id", { table_number: tableName, status: "1" });

    //  handlediscount({ target: { value: "0" } });
  };

  // Toggle merge mode
  const toggleMergeMode = () => {
    setIsMergeMode(!isMergeMode);
    setSelectedTables([]);
    setSelectedTable(null);
    setFinalData([]);
    setIsBillSaved(false);
    toast.info(isMergeMode ? "Merge mode disabled" : "Merge mode enabled - Select multiple tables");
  };

  // Handle table selection in merge mode
  const handleTableSelection = async (tableName) => {
    if (isMergeMode) {
      let newSelectedTables;
      // In merge mode, allow multiple table selection
      if (selectedTables.includes(tableName)) {
        // Remove table if already selected
        newSelectedTables = selectedTables.filter(table => table !== tableName);
        setSelectedTables(newSelectedTables);
        toast.info(`Table ${tableName} removed from selection`);
      } else {
        // Add table to selection
        newSelectedTables = [...selectedTables, tableName];
        setSelectedTables(newSelectedTables);
        toast.success(`Table ${tableName} added to selection`);
      }
      
      // Automatically merge and show bill summary when tables are selected
      if (newSelectedTables.length > 0) {
        await autoMergeTables(newSelectedTables);
      } else {
        // Clear bill data if no tables selected
        setFinalData([]);
        setSelectedTable(null);
      }
    } else {
      // Normal single table selection
      handleTableHistory(tableName);
    }
  };

  // Auto-merge function to show bill summary immediately
  const autoMergeTables = async (tablesToMerge) => {
    try {
      // Fetch order items from all selected tables
      const allOrderItems = [];
      for (const tableName of tablesToMerge) {
        const tableOrders = await fetchData("order_items", null, "id", { 
          table_number: tableName, 
          status: "1" 
        });
        if (tableOrders && tableOrders.length > 0) {
          allOrderItems.push(...tableOrders);
        }
      }

      if (allOrderItems.length === 0) {
        setFinalData([]);
        setSelectedTable(null);
        return;
      }

      // Combine items with same name by adding quantities and totals
      const mergedItems = {};
      allOrderItems.forEach(item => {
        if (mergedItems[item.item_name]) {
          // Item already exists, combine quantities and totals
          mergedItems[item.item_name].quantity += item.quantity;
          mergedItems[item.item_name].total_price += parseFloat(item.total_price);
        } else {
          // New item, add to merged items
          mergedItems[item.item_name] = {
            ...item,
            total_price: parseFloat(item.total_price)
          };
        }
      });

      // Convert back to array
      const finalMergedData = Object.values(mergedItems);
      
      setFinalData(finalMergedData);
      setSelectedTable(`Merged: ${tablesToMerge.join(', ')}`);
      setIsBillSaved(false);
      
    } catch (error) {
      console.error("Error auto-merging tables:", error);
      toast.error("Error occurred while merging tables");
    }
  };

  // Merge selected tables and show combined bill
  const handleMergeTables = async () => {
    if (selectedTables.length < 2) {
      toast.error("Please select at least 2 tables to merge");
      return;
    }

    // Use the auto-merge function
    await autoMergeTables(selectedTables);
    toast.success(`Successfully merged ${selectedTables.length} tables`);
  };


  // Runs when discAmount or discountType changes
  useEffect(() => {
    if (finalData.length === 0 || !TaxesData || TaxesData.length === 0) return; // Prevent running when there's no data

    let discountAmount = parseFloat(discAmount) || 0;

    // Calculate subtotal safely
    const subtotalValue = finalData.reduce((acc, item) => acc + (Number(item.total_price) || 0), 0);
    setSubtotal(subtotalValue.toFixed(2));

    // Adjust discount calculation based on type
    if (formdata.discountType === "percentage") {
      discountAmount = Math.min((subtotalValue * discountAmount) / 100, subtotalValue); // Prevent over-discount
    } else {
      discountAmount = Math.min(discountAmount, subtotalValue); // Prevent over-discount for amount
    }

    // Calculate subtotal after discount
    const subtotalAfterDiscount = subtotalValue - discountAmount;
    setsubtotalAfterDiscount(subtotalAfterDiscount.toFixed(2));

    // Calculate tax based on settings
    let taxValue = 0;
    let totalAmountValue = 0;
    
    const taxRate = parseFloat(TaxesData[0].taxvalue) || 0;
    
    if (TaxesData[0].included === "true") {
      // Tax included in price
      taxValue = (subtotalAfterDiscount * taxRate) / (100 + taxRate);
      totalAmountValue = subtotalAfterDiscount;
    } else {
      // Tax excluded from price
      taxValue = subtotalAfterDiscount * (taxRate / 100);
      totalAmountValue = subtotalAfterDiscount + taxValue;
    }
    
    settaxAmount(taxValue.toFixed(2));
    settotalAmount(totalAmountValue.toFixed(2));

    // Round-off amount
    const roundedTotal = Math.round(totalAmountValue);
    const roundoffValue = roundedTotal - totalAmountValue;
    setroundoffAmount(roundoffValue.toFixed(2));

    // Set final grand total
    setgrandAmount(roundedTotal.toFixed(2));

  }, [discAmount, formdata.discountType, finalData, TaxesData]); // Added TaxesData to dependencies


  const handleBillHistory = async () => {
    navigate(`/reports/billhistory`);
  };

  // ✅ Send bill summary to customer display
  const sendBillSummaryToCustomerDisplay = () => {
    if (customerDisplayManager.isDisplayConnected() && finalData.length > 0) {
      try {
        // Prepare bill summary data
        const billSummary = {
          tableNumber: selectedTable,
          items: finalData.map(item => ({
            iname: item.item_name,
            item_name: item.item_name,
            quantity: item.quantity,
            offerprice: item.total_price / item.quantity,
            price: item.total_price / item.quantity,
            total_price: item.total_price
          })),
          subtotal: subtotal,
          discount: discAmount,
          discountType: formdata.discountType,
          subtotalAfterDiscount: subtotalAfterDiscount,
          tax: taxAmount,
          grandTotal: grandAmount,
          paymentMode: formdata.pmode,
          status: 'BILL_CONFIRMATION',
          message: 'Please confirm your order'
        };

        // Send bill confirmation to customer display
        customerDisplayManager.sendBillConfirmation(billSummary);
        
        console.log("Bill summary sent to customer display");
      } catch (error) {
        console.error("Error sending bill summary to customer display:", error);
      }
    }
  };

  // ✅ Handle modal close and clear customer display
  const handleModalClose = () => {
    // Clear bill confirmation from customer display
    if (customerDisplayManager.isDisplayConnected()) {
      customerDisplayManager.sendCustomMessage('NORMAL_MODE', 'normal');
    }
    
    // Call the original onClose function
    onClose();
  };

  const handlePrintClick = async (itemId) => {
    try {

      const invId = itemId;
      //alert(invId);
      // Fetch the final_bill and order_items details for the given itemId
      const myfinalbilldata = await fetchData("final_bill", setFinalBillData, "id", { id: invId });
      const myOrderItemsData = await fetchData("order_items", setOrderItemsData, "id", { invoice_number: invId });
      // Check if inv_time exists in finalBillData
      const invTime = myfinalbilldata[0].inv_time;
      const formattedTime = invTime ? invTime.split(':').slice(0, 2).join(':') : 'N/A'; // Use 'N/A' if inv_time is undefined

      // Format the data for printing using a similar structure
      const printContent = `
        <html>
          <head>
            <style>
              html, body {
                margin: 0;
                padding: 0;
                font-family: 'Cambria', monospace;
              }
              body {
                font-size: 18px;
                width: 80mm;
              }
              .bill-header {
                text-align: center;
                margin-bottom: 2px;
              }
              .bill-header h2 {
                margin: 0;
                font-size: 24px;
                font-weight: bold;
              }
              .bill-header p {
                margin: 4px 0;
                font-size: 18px;
              }
              .table {
                width: 100%;
                margin-top: 1px;
                border-collapse: collapse;
              }
              .table th, .table td {
                text-align: left;
                padding: 5px 0;
                font-size: 18px;
                line-height: 1.6;
              }
              .table th {
                font-weight: bold;
                border-bottom: 1px solid #000;
              }
              .table th.header {
                font-weight: bold;
                
              }
              .table td {
                border-bottom: 1px solid #ddd;
              }
              .table td.total {
                font-weight: bold;
                font-size: 18px;
                margin-right: 2px;
                border-bottom: 1px solid #000;
              }
              .total-row {
                margin-top: 5px;
                margin-right: 10px;
                font-weight: bold;
                text-align: right;
                font-size: 18px;
              }
              .footer {
                margin-top: 15px;
                text-align: center;
                font-size: 18px;
              }
            </style>
          </head>
          <body>
            <div class="bill-header">
               <h2>${companyInfo[0].name}</h2>
            <div class="company-info">
              <p>${companyInfo[0].address}</p>
              <p>${companyInfo[0].phone_number}</p>
              <p>Tax:${companyInfo[0].tax_id}</p>
            
           
            </div>
             
           
          
          </div>
            <div class="bill-bill-body">
             
              <table class="table">
                
                  <tr >
                    <td class="header" >Bill ID: ${myfinalbilldata[0].id}</td>
                   
                    <td class="header" >${myfinalbilldata[0].table_number}</td>
                    
                  </tr>
                   <tr >
                    <td>Date: ${myfinalbilldata[0].inv_date}</td>
                   
                    <td>Time:${formattedTime}</td>
                    
                  </tr>
                
                <tbody> 
                <tr>  </tr>
                <tr>  </tr>
                </tbody>
                </table>
             
            </div>
            <div class="bill-body">
              <table class="table">
                <thead>
                  <tr>
                    <th>Item Name</th>
                    <th>Qty</th>
                    <th>Rate</th>
                    <th>Total </th>
                  </tr>
                </thead>
                <tbody>
                  ${myOrderItemsData
          .map(
            (item) => `
                        <tr>
                          <td>${item.item_name}</td>
                          <td>${item.quantity}</td>
                          <td>${currencySign} ${item.total_price / item.quantity}</td>
                          <td>${currencySign} ${item.total_price}</td>
                        </tr>
                      `
          )
          .join('')}
                </tbody>
              </table>
               <div class="total-row">
              <span>Subtotal: ${currencySign} ${myfinalbilldata[0].subtotal}</span><br>
              <span>Discount: ${currencySign} ${myfinalbilldata[0].discount_amount}</span><br>
              <span>Subtotal After Discount: ${currencySign} ${myfinalbilldata[0].subtotal_afterdiscount}</span><br>

              <span>Tax (7%): ${currencySign} ${myfinalbilldata[0].tax}</span><br>
              <span>Round Off: ${currencySign} ${myfinalbilldata[0].roundoff}</span><br>
              <span>Total Amount: ${currencySign} ${myfinalbilldata[0].grand_total}</span>
            </div>
              
            </div>
            <div class="footer">
              <p>Printed on ${new Date().toLocaleString()}</p>
              <p>Cashier: ${getUserName() || 'N/A'}</p>
              <p>Powered by ${companyInfo[0].developer}</p>
            </div>
          </body>
        </html>
      `;

      // Open the print dialog with the formatted content
      const newWindow = window.open("", "_blank");
      newWindow.document.write(printContent);
      newWindow.document.close();

      newWindow.onload = () => {
        newWindow.print(); // Print the document
        newWindow.close(); // Close the window after printing
      };
    } catch (error) {
      console.error("Error fetching data for printing:", error);
    }
  };

  const calculateTaxedTotal = async (subtotal) => {
    try {
      // const response = await axios.get("/api/taxes/active", getHeaders());
      const response = await fetchData("taxes", setTotaltablelist, "id", { status: "active" });
      const taxes = response.data;

      let finalSubtotal = subtotal;
      let total = subtotal;
      const taxDetails = [];

      taxes.forEach((tax) => {
        const rate = parseFloat(tax.taxvalue);

        if (tax.included) {
          const taxAmount = (subtotal * rate) / (100 + rate);
          finalSubtotal -= taxAmount;
          taxDetails.push({
            name: tax.taxname,
            amount: taxAmount.toFixed(2),
            included: true,
          });
        } else {
          const taxAmount = (finalSubtotal * rate) / 100;
          total += taxAmount;
          taxDetails.push({
            name: tax.taxname,
            amount: taxAmount.toFixed(2),
            included: false,
          });
        }
      });

      return {
        subtotal: finalSubtotal.toFixed(2),
        total: total.toFixed(2),
        taxes: taxDetails,
      };
    } catch (err) {
      console.error("Failed to fetch or calculate taxes", err);
      return {
        subtotal: subtotal.toFixed(2),
        total: subtotal.toFixed(2),
        taxes: [],
      };
    }
  };


  const handleSaveBill = async () => {
    try {
      // Validate payment mode is selected
      if (!formdata.pmode || formdata.pmode === "") {
        toast.error("Please select a payment mode before saving the bill.");
        return;
      }

      console.log("Current formdata.pmode:", formdata.pmode); // ✅ Debug payment mode
      console.log("Full formdata:", formdata); // ✅ Debug full form data

      // Validate customer details if payment mode is Credit
      if (formdata.pmode === "Credit" && (!customerDetails.name || !customerDetails.phone || !customerDetails.email)) {
        toast.error("Please enter customer details before saving the bill for Credit payment.");
        setCustomerModalOpen(true);
        return;
      }

      // Validate that we have tax data
      if (!TaxesData || TaxesData.length === 0) {
        toast.error("Tax information not loaded. Please try again.");
        return;
      }

      // Validate that we have items to bill
      if (!finalData || finalData.length === 0) {
        toast.error("No items to bill. Please add items first.");
        return;
      }

      // Validate that a table is selected
      if (!selectedTable) {
        toast.error("Please select a table before saving the bill.");
        return;
      }

      console.log("Starting bill save process for payment mode:", formdata.pmode);

      // Calculate subtotal safely (same as useEffect calculation)
      const calculatedSubtotal = finalData.reduce((acc, item) => acc + (Number(item.total_price) || 0), 0);
      
      // Calculate discount amount based on the type (same as useEffect)
      let finaldiscount_amount = parseFloat(discAmount) || 0;
      if (formdata.discountType === "percentage") {
        finaldiscount_amount = Math.min((calculatedSubtotal * finaldiscount_amount) / 100, calculatedSubtotal);
      } else {
        finaldiscount_amount = Math.min(finaldiscount_amount, calculatedSubtotal);
      }
      
      // Calculate subtotal after discount
      const calculatedSubtotalAfterDiscount = calculatedSubtotal - finaldiscount_amount;
      
      // Calculate tax based on settings (same as useEffect)
      let calculatedTaxAmount = 0;
      let calculatedTotalAmount = 0;
      
      if (TaxesData[0].included === "true") {
        // Tax included calculation
        calculatedTaxAmount = (calculatedSubtotalAfterDiscount * TaxesData[0].taxvalue) / (100 + TaxesData[0].taxvalue);
        calculatedTotalAmount = calculatedSubtotalAfterDiscount;
      } else {
        // Tax excluded calculation
        calculatedTaxAmount = calculatedSubtotalAfterDiscount * (TaxesData[0].taxvalue / 100);
        calculatedTotalAmount = calculatedSubtotalAfterDiscount + calculatedTaxAmount;
      }
      
      // Calculate round off
      const roundedTotal = Math.round(calculatedTotalAmount);
      const calculatedRoundoffAmount = roundedTotal - calculatedTotalAmount;
      
      // Final grand total
      const calculatedGrandTotal = roundedTotal;
      
      // Determine bill status - 0 for paid, 1 for unpaid/credit
      let billstatus = 0; // Default to paid
      if (formdata.pmode === "Credit") {
        billstatus = 1; // Unpaid for credit
      }

      //prepare the request body
      const setupDate = await getNextSetupDate(); // ✅ Get next setup date
      
      const billData = {
        customer_id: formdata.pmode === "Credit" ? customerDetails.custid || null : null,
        tablenumber: selectedTables.length > 0 ? selectedTables.join(', ') : (selectedTable || ""),
        subtotal: calculatedSubtotal.toFixed(2),
        discount_type: formdata.discountType || "amount",
        discount_value: parseFloat(discAmount) || 0,
        discount_amount: finaldiscount_amount.toFixed(2),
        subtotal_afterdiscount: calculatedSubtotalAfterDiscount.toFixed(2),
        tax: calculatedTaxAmount.toFixed(2),
        total_amount: calculatedTotalAmount.toFixed(2),
        round_off: calculatedRoundoffAmount.toFixed(2),
        grand_total: calculatedGrandTotal.toFixed(2),
        payment_mode: formdata.pmode || "Cash", // ✅ Ensure payment mode is not empty
        status: billstatus,
        setup_date: setupDate // ✅ Add setup_date column
      };

      console.log('Payment mode being sent to API:', billData.payment_mode); // ✅ Debug API data
      console.log('Full billData object:', billData); // ✅ Debug full object

      // ✅ Additional validation to ensure payment_mode is valid
      if (!billData.payment_mode || billData.payment_mode.trim() === "") {
        billData.payment_mode = "Cash"; // Force default to Cash
        console.warn("Payment mode was empty, defaulting to Cash");
      }

      // Add detailed logging for payment mode
      console.log('Payment mode details:');
      console.log('- formdata.pmode:', formdata.pmode);
      console.log('- typeof formdata.pmode:', typeof formdata.pmode);
      console.log('- billData.payment_mode:', billData.payment_mode);
      console.log('- typeof billData.payment_mode:', typeof billData.payment_mode);

      // Validate calculated values match display values
      const displaySubtotal = parseFloat(subtotal);
      const displayGrandTotal = parseFloat(grandAmount);
      
      if (Math.abs(calculatedSubtotal - displaySubtotal) > 0.01) {
        console.warn("Subtotal mismatch:", { calculated: calculatedSubtotal, display: displaySubtotal });
      }
      
      if (Math.abs(calculatedGrandTotal - displayGrandTotal) > 0.01) {
        console.warn("Grand total mismatch:", { calculated: calculatedGrandTotal, display: displayGrandTotal });
      }

      console.log('Sending bill data to API:', billData);
      
      // Add detailed logging for payment mode
      console.log('Payment mode details:');
      console.log('- formdata.pmode:', formdata.pmode);
      console.log('- typeof formdata.pmode:', typeof formdata.pmode);
      console.log('- billData.payment_mode:', billData.payment_mode);
      console.log('- typeof billData.payment_mode:', typeof billData.payment_mode);

      // Save the final bill and ledger entries simultaneously in one request
      const response = await axios.post(
        "/savebill",  // API route that saves both bill & ledger
        billData,
        getHeaders()
      );

      console.log('API Response:', response.data);

      if (!response.data || !response.data.bill_id) {
        throw new Error("Invalid response from server - no bill ID returned");
      }

      const { bill_id } = response.data; // Get the inserted bill ID
      setLatestBillId(bill_id);

      console.log('Bill saved successfully with ID:', bill_id);

      // Update table status - handle both single table and merged tables
      if (selectedTables.length > 0) {
        // Merged tables scenario
        for (const tableName of selectedTables) {
          await updateData(
            "tablelist",
            { status: "0" }, // Mark table as "closed"
            { name: tableName }
          );
          
          // Update order items for each table
          await updateData("order_items", {
            status: "0", // Mark orders as completed
            invoice_number: bill_id, // Attach the invoice number
            setup_date: setupDate // ✅ Add setup_date when updating order_items
          },
            {
              table_number: tableName, // Match the table number
              status: "1", // Only update active orders
            }
          );
        }
      } else {
        // Single table scenario
        await updateData(
          "tablelist",
          { status: "0" }, // Mark table as "closed"
          { name: selectedTable }
        );

        // Update order items status and attach invoice number
        await updateData("order_items", {
          status: "0", // Mark orders as completed
          invoice_number: bill_id, // Attach the invoice number
          setup_date: setupDate // ✅ Add setup_date when updating order_items
        },
          {
            table_number: selectedTable, // Match the table number
            status: "1", // Only update active orders
          }
        );
      }

      // Refresh the table list
      await fetchData("tablelist", setTotaltablelist, "id", { status: "1" });

      // Show success toast message
      toast.success(`Bill saved successfully! Bill ID: ${bill_id}`);
      setIsBillSaved(true);
      
    } catch (err) {
      console.error("Error occurred during bill save:", err);
      toast.error(`Error saving bill: ${err.message || 'Unknown error'}`);
    }
  };
  // useEffect(() => {
  //   if (latestBillId) {
  //     handlePrintClick(latestBillId);
  //   }
  // }, [latestBillId]);



  const handlePrintBill = async () => {
    try {
      // Check if bill is already saved
      if (!isBillSaved) {
        toast.error("Please save the bill first before printing.");
        return;
      }

      // Now show the print preview
      const printContent = printRef.current.innerHTML;

      const newWindow = window.open("", "_blank");

      newWindow.document.write(`
        <html>
          <head>
            <style>
              html, body {
                margin: 0;
                padding: 0;
                font-family: 'Cambria', monospace; /* Common font for receipts */
              }
              body {
                font-size: 18px; /* Increased font size for better readability */
                width: 80mm; /* Common thermal printer size */
              }
              .bill-header {
                display: grid;
                grid-template-columns: 1fr 1fr;
                grid-gap: 5px;
                text-align: center;
                margin-bottom: 10px;
              }
            .bill-header h2 {
              grid-column: span 2;
              margin: 0;
              font-size: 24px; /* Larger header */
              font-weight: bold;
            }
            .bill-header .company-info {
              grid-column: span 3;
              text-align: center;
            }
            .bill-header .company-info p {
              margin: 4px 0;
              font-size: 18px; /* Larger text for better readability */
            }
            .bill-header .contact-info {
              display: flex;
              justify-content: center;
              grid-column: span 2;
            }
            .bill-header .left-col {
              text-align: left;
            }
            .bill-header .right-col {
              text-align: right;
              margin-right:20px;
              
            }
            .bill-header .tax-id {
              text-align: left;
              grid-column: span 2;
              font-size: 16px;
              margin:0;
            }
            .table {
              width: 100%;
              margin-top: 1px;
              border-collapse: collapse;
            }
            .table th, .table td {
              text-align: left;
              padding: 5px 0; /* Adjust padding to make text fit better */
              font-size: 18px; /* Larger font size for readability */
              line-height: 1.6; /* Increase line height for better readability */
            }
            .table th {
              font-weight: bold;
              border-bottom:1px solid #000;
            }
            .table td {
              border-bottom: 1px solid #ddd;
            }
            .table td.total {
              font-weight: bold;
              font-size: 18px; /* Larger font for totals */
              margin-right:2px;
              border-bottom:1px solid #000;
            }
            .total-row {
              margin-top: 5px;
              margin-right: 10px;
              font-weight: bold;
              text-align: right;
              font-size: 18px;
              line-height: 1.6; /* Larger font size for totals */
            }
            .total-row span {
              margin-left: 0px;
            }
            .footer {
              margin-top: 15px;
              text-align: center;
              font-size: 18px; /* Larger footer font */
            }
          </style>
        </head>
        <body>
          <div class="bill-header">
            <h2>${companyInfo[0].name}</h2>
            <div class="company-info">
              <p>${companyInfo[0].address}</p>
              <p>Tax:${companyInfo[0].tax_id}</p>
            </div>
          </div>
          <div class="bill-bill-body">
            <table class="table">
              <tr>
                <th class="header">Bill ID: ${latestBillId}</th>
                <th class="header">${selectedTable}</th>
              </tr>
              <tr>
                <th>Date: ${getCurrentDate()}</th>
                <th>Time: ${getCurrentTime()}</th>
              </tr>
              <tr>
                <th colspan="2">Payment Mode: ${formdata.pmode || 'Cash'}</th>
              </tr>
              <tbody> 
                <tr></tr>
                <tr></tr>
              </tbody>
            </table>
          </div>
          <div class="bill-body">
            <table class="table">
              <thead>
                <tr>
                  <th>Item</th>
                  <th>Qty</th>
                  <th>Rate</th>
                  <th>Total</th>
                </tr>
              </thead>
              <tbody>
                ${finalData
        .map(
          (item) => `
                  <tr>
                    <td>${item.item_name}</td>
                    <td>${item.quantity}</td>
                    <td>${currencySign} ${Number(item.total_price / item.quantity).toFixed(2)}</td>
                    <td>${currencySign} ${Number(item.total_price).toFixed(2)}</td>
                 
                  </tr>
                `
        )
        .join("")}
              </tbody>
            </table>
            <div class="total-row">
              <span>Subtotal: ${currencySign} ${subtotal}</span><br>
              <span>Discount: ${formdata.discountType === "percentage" ? `${discAmount}%` : `${currencySign} ${discAmount}`}</span><br>
              <span>Subtotal after Discount: ${currencySign} ${subtotalAfterDiscount}</span><br>
              <span>Tax (7%): ${currencySign} ${taxAmount}</span><br>
              <span>Round Off: ${currencySign} ${roundoffAmount}</span><br>
              <span>Total Amount: ${currencySign} ${grandAmount}</span>
            </div>
          </div>
          <div class="footer">
            <p>Operated By: ${getUserName() || 'N/A'}</p>
            <p>Powered by CloudPOS !! </p>
          </div>
        </body>
      </html>
    `);



    newWindow.document.close();

    newWindow.onload = () => {
      newWindow.print(); // Print the document
      newWindow.close(); // Close the window after printing
      
      // Notify customer display that bill is completed
      customerDisplayManager.sendCustomMessage("Bill printed successfully. Thank you for your visit!");
      
      // Clear bill confirmation after a short delay
      setTimeout(() => {
        customerDisplayManager.clearCustomerDisplay();
      }, 3000);
    };
    
    } catch (error) {
      console.error("Error in print and save:", error);
      toast.error("Error occurred while saving and printing bill.");
    }
  };
  useEffect(() => {
    if (finalData.length > 0) {
      setIsBillSaved(false);
    }
  }, [finalData]);

  useEffect(() => {
    const fetchAndSetData = async () => {
      try {
        await fetchData("taxes", setTaxesData, "id", { status: "Active" });
        await fetchData("tablelist", setTotaltablelist, "id", { status: "1" });
        await fetchData("companyinfo", setcompanyInfo, "id", {});
        await setpaymentOptions(await fetchComboData("paymentoptions", "name"));
        
        // Fetch currency sign from coresetting table
        const coreSettings = await fetchData("coresetting", null, "id", {});
        if (coreSettings && coreSettings.length > 0) {
          const currencyFromSettings = coreSettings.find(setting => setting.setting_name === "currency_sign");
          if (currencyFromSettings) {
            setCurrencySign(currencyFromSettings.setting_value);
          }
        }
      } catch (error) {
        console.error("Error in useEffect:", error);
      }
    };

    fetchAndSetData();
  }, []);  // ✅ This ensures it runs only once when the component mounts

  // useEffect to handle refresh trigger from parent component (when KOT is sent)
  useEffect(() => {
    if (refreshTrigger && isOpen) {
      console.log("Refresh trigger received, updating table list...");
      fetchData("tablelist", setTotaltablelist, "id", { status: "1" });
    }
  }, [refreshTrigger, isOpen]);

  // useEffect to auto-refresh table list when modal opens
  useEffect(() => {
    if (isOpen) {
      console.log("Modal opened, refreshing table list...");
      fetchData("tablelist", setTotaltablelist, "id", { status: "1" });
      
      // ✅ Send bill summary to customer display when modal opens
      setTimeout(() => {
        sendBillSummaryToCustomerDisplay();
      }, 500); // Small delay to ensure data is loaded
    }
  }, [isOpen, finalData, selectedTable, subtotal, grandAmount]); // Added dependencies


  // Dependency array ensures it runs only when finalData updates
  // Runs only when `latestBillId` updates
  const [showLineQR, setShowLineQR] = useState(false);
  const [lineDiscountEligible, setLineDiscountEligible] = useState(false);

  const handleLineDiscount = async () => {
    if (!customerDetails.phone) {
      toast.warning("Please enter customer phone number first.");
      setLineQRModalOpen(true);
      return;
    }

    try {
      const res = await axios.post('/checkline', {
        phone: customerDetails.phone
      });

      if (res.data.eligible) {
        setShowLineQR(true);
      } else {
        toast.error("You have already claimed the LINE discount.");
      }
    } catch (err) {
      toast.error("Error checking LINE discount eligibility.");
      console.error(err);
    }
  };

  return (
    <>

      <Modal
        isOpen={isOpen}
        onRequestClose={onClose}
        contentLabel="New Item Entry"
        style={customStyles}
        ariaHideApp={false}
      >
        <div className="bill-modal-container">
          <ToastContainer />
          
          {/* Header */}
          <div className="bill-modal-header">
            <h2 className="bill-modal-title">Final Summary - {selectedTable}</h2>
            <div className="bill-modal-actions">
              <button onClick={refreshTables} className="refresh-btn">
                <FaRedo size={16} />
              </button>
              <button onClick={handleModalClose} className="close-btn">
                <FaTimes size={16} />
              </button>
            </div>
          </div>

          {/* Tables Section */}
          <div className="tables-section">
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "15px" }}>
              <h4 style={{ margin: "0", color: "#495057" }}>Running Tables List</h4>
              <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                <button
                  onClick={toggleMergeMode}
                  className={`btn ${isMergeMode ? 'btn-warning' : 'btn-info'}`}
                  style={{ fontSize: "12px", padding: "5px 10px" }}
                >
                  {isMergeMode ? 'Exit Merge' : 'Merge Tables'}
                </button>
                {isMergeMode && selectedTables.length > 0 && (
                  <span style={{ fontSize: "12px", color: "#28a745", fontWeight: "bold" }}>
                    {selectedTables.length} table{selectedTables.length > 1 ? 's' : ''} selected
                  </span>
                )}
              </div>
            </div>
            
            {isMergeMode && (
              <div style={{ marginBottom: "10px", padding: "8px", backgroundColor: "#e3f2fd", borderRadius: "4px", fontSize: "12px" }}>
                <strong>Merge Mode:</strong> Click on tables to select them for merging. Bill summary will update automatically. 
                {selectedTables.length > 0 && (
                  <span style={{ color: "#28a745", fontWeight: "bold" }}>
                    <br />Selected: {selectedTables.join(', ')}
                  </span>
                )}
              </div>
            )}
            
            <div className="tables-grid">
              {TotalTablelist.length > 0 ? (
                TotalTablelist.map((tables, index) => (
                  <div
                    key={index}
                    onClick={() => handleTableSelection(tables.name)}
                    className={`table-card ${tables.status === 0 ? "available" : "occupied"} ${
                      isMergeMode && selectedTables.includes(tables.name) ? "selected-for-merge" : ""
                    } ${!isMergeMode && selectedTable === tables.name ? "active-table" : ""}`}
                  >
                    <img
                      src={`../../dist/img/tables/table.png`}
                      alt={`Table ${index + 1}`}
                      onError={(e) => {
                        e.target.src = "../../dist/img/tables/table.png";
                      }}
                    />
                    <h6>{tables.name}</h6>
                    <span className={`table-status ${tables.status === 0 ? "available" : "occupied"}`}>
                      {tables.status === 0 ? "Available" : "Occupied"}
                    </span>
                  </div>
                ))
              ) : (
                <div className="loading-message">Loading tables...</div>
              )}
            </div>
          </div>

        
        {/* Horizontal rule */}
        {/* Main Content */}
          <div className="bill-content">
            {/* Left Side - Bill Summary */}
            <div className="bill-summary-section" ref={printRef}>
              <div className="bill-summary-header">
                Bill Summary
              </div>
              
              <div className="bill-table-container">
                <table className="bill-table">
                  <thead>
                    <tr>
                      <th className="text-start">Item</th>
                      <th>Qty</th>
                      <th>Unit Price</th>
                      <th className="text-end">Total Price</th>
                    </tr>
                  </thead>
                  <tbody>
                    {finalData.length > 0 ? (
                      finalData.map((item, index) => (
                        <tr key={index}>
                          <td className="text-start">{item.item_name}</td>
                          <td>{item.quantity}</td>
                          <td>{currencySign} {(item.total_price / item.quantity).toFixed(2)}</td>
                          <td className="text-end">{currencySign} {Number(item.total_price).toFixed(2)}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="4" className="empty-table-message">
                          Table is Empty
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              {finalData.length > 0 && (
                <div className="bill-totals">
                  <div className="total-row">
                    <span className="label">Subtotal</span>
                    <span className="value">{currencySign} {subtotal}</span>
                  </div>
                  <div className="total-row">
                    <span className="label">Discount</span>
                    <span className="value">
                      {formdata.discountType === "percentage" ? `${discAmount}%` : `${currencySign} ${discAmount}`}
                    </span>
                  </div>
                  <div className="total-row">
                    <span className="label">Subtotal After Discount</span>
                    <span className="value">{currencySign} {subtotalAfterDiscount}</span>
                  </div>
                  <div className="total-row">
                    <span className="label">Tax ({TaxesData[0]?.taxvalue || 0}%)</span>
                    <span className="value">{currencySign} {taxAmount}</span>
                  </div>
                  <div className="total-row">
                    <span className="label">Total Amount</span>
                    <span className="value">{currencySign} {totalAmount}</span>
                  </div>
                  <div className="total-row">
                    <span className="label">Round Off Amount</span>
                    <span className="value">{currencySign} {roundoffAmount}</span>
                  </div>
                  <div className="total-row">
                    <span className="label">Grand Total</span>
                    <span className="value">{currencySign} {grandAmount}</span>
                  </div>
                </div>
              )}
            </div>

            {/* Right Side - Payment & Customer Info */}
            <div className="payment-section">
              {/* Customer Information Card */}
              <div className="payment-card">
                <div className="payment-card-header">
                  Customer Information
                </div>
                <div className="payment-card-body">
                  <div className="form-group">
                    <label>Customer Mobile Number</label>
                    <input
                      type="number"
                      className="form-control"
                      value={phones}
                      onChange={(e) => setphones(e.target.value)}
                      placeholder="Enter mobile number"
                    />
                  </div>
                  <button
                    onClick={() => setCustomerModalOpen(true)}
                    className="btn btn-info btn-full-width"
                  >
                    Add Customer Details
                  </button>
                </div>
              </div>

              {/* Payment Details Card */}
              <div className="payment-card">
                <div className="payment-card-header">
                  Payment Details
                </div>
                <div className="payment-card-body">
                  <div className="form-group">
                    <label>Payment Mode</label>
                    <select
                      className="form-select"
                      value={formdata.pmode}
                      onChange={handleComboChange}
                    >
                     
                      {paymentOptions.map((pmt) => (
                        <option key={pmt.name} value={pmt.name}>
                          {pmt.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="form-group">
                    <label>Amount Received</label>
                    <input
                      type="text"
                      className="form-control"
                      value={formdata.paidAmount}
                      onChange={handleChangeMoney}
                      placeholder="Enter received amount"
                    />
                  </div>

                  <div className="form-group">
                    <label>Change Money</label>
                    <input
                      type="text"
                      className={`form-control change-money ${changeMoney >= 0 ? 'positive' : 'negative'}`}
                      value={`${currencySign} ${changeMoney}`}
                      readOnly
                    />
                  </div>
                </div>
              </div>

              {/* Discount Card */}
              <div className="payment-card">
                <div className="payment-card-header">
                  Discount Options
                </div>
                <div className="payment-card-body">
                  <div className="discount-controls">
                    <div className="discount-input">
                      <label>Discount Amount</label>
                      <input
                        type="number"
                        className="form-control"
                        value={discAmount}
                        onChange={(e) => setDiscAmount(e.target.value)}
                        placeholder="Enter discount"
                      />
                    </div>
                    <div className="discount-type-select">
                      <label>Type</label>
                      <select
                        className="form-select"
                        value={formdata.discountType}
                        onChange={(e) => setFormData(prev => ({ ...prev, discountType: e.target.value }))}
                      >
                        <option value="percentage">%</option>
                        <option value="fixed">{currencySign}</option>
                      </select>
                    </div>
                  </div>

                  <div className="action-buttons">
                    <button
                      onClick={() => {
                        if (!phones) {
                          toast.error("Please enter customer phone first.");
                          return;
                        }
                        setLineQRModalOpen(true);
                      }}
                      className="btn btn-warning"
                    >
                      LINE Discount
                    </button>
                    <button
                      onClick={() => {
                        if (!customerDetails.phone) {
                          toast.error("Please enter customer phone first.");
                          return;
                        }
                        setLineQRModalOpen(true);
                      }}
                      className="btn btn-info"
                    >
                      WhatsApp Discount
                    </button>
                  </div>
                </div>
              </div>

              {/* Action Buttons */}
              <div className="payment-card">
                <div className="payment-card-body">
                  <div className="action-buttons">
                    {!isBillSaved && (
                      <button
                        onClick={handleSaveBill}
                        className="btn btn-success"
                        disabled={!finalData || finalData.length === 0}
                      >
                        Save Bill
                      </button>
                    )}
                    {isBillSaved && (
                      <button
                        onClick={handlePrintBill}
                        className="btn btn-primary"
                      >
                        Print Bill
                      </button>
                    )}
                    <button
                      onClick={handleBillHistory}
                      className="btn btn-info"
                    >
                      Bill History
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
      <LineQRDiscountModal
        isOpen={isLineQRModalOpen}
        onClose={() => setLineQRModalOpen(false)}
        onConfirm={() => {
          setDiscAmount(10);
          setFormData(prev => ({ ...prev, discountType: "percentage" })); // ✅ SAFE UPDATE
        }}
      />


      <CustomerDetailsModal
        isOpen={isCustomerModalOpen}
        customer={customerDetails}
        onClose={() => setCustomerModalOpen(false)}
        onSaveCustomerDetails={(details) => {
          setCustomerDetails(details);
          setCustomerModalOpen(false);
        }}
      />
    </>
  );
};

export default CheckBillModal;
